export default __webpack_public_path__ + "static/media/bg-masthead-2-800w.86515354.webp";